import MapHandler from "../map/MapHandler";
// import jqueryui
import "jquery-ui/ui/widgets/dialog.js";
import $ from "jquery";
import { VisCategory } from "../../interfaces/resource.interfaces";
import * as d3 from "d3";

export default class ChartInteraction {
  #menuContainer;
  #legendWrapper!: JQuery;
  #feature;
  #imgContainer: JQuery; //For continuous color scale

  #canvas;
  #legendLabel;

  #buttons; //buttons[0] = invert colors, buttons[1] = color picker

  // color picker + invert colors
  #inverted;
  #squaresColor;

  // custom scale
  #customScaleMin;
  #customScaleMax;
  #customScaleBool;
  #customMinColor;
  #customMaxColor;
  #customMiddleColor;
  #interpolateBool;
  dialog!: JQuery;

  static #instance: ChartInteraction;

  static getInstance() {
    if (!this.#instance) {
      this.#instance = new ChartInteraction(
        `#interactionControlSquares`,
        "Squares"
      );
    }

    return this.#instance;
  }

  constructor(menuContainer: any, feature: VisCategory) {
    this.#inverted = false;
    this.#squaresColor = "#08306b";
    this.#menuContainer = menuContainer; // '#interactionControlSquares' or '#interactionControlBuildings'
    this.#feature = feature; // 'Squares' or 'Buildings'
    this.#customScaleMin = 0.0;
    this.#customScaleMax = 100.0;
    this.#customScaleBool = false;
    this.#customMinColor = "#9e9e9e"; // helles grau
    this.#customMaxColor = "#545353"; // dunkles grau
    this.#customMiddleColor = "#d17d00"; // orange
    this.#interpolateBool = false;

    if (feature === "Squares") {
      this.#legendWrapper = $("#bottomRightContent").find(
        "#legendWrapperSquares"
      );
      this.#canvas = this.#legendWrapper.find(".legendCanvas");
      this.#legendLabel = this.#legendWrapper.find("#legendLabelSquares");
    } /* else if (feature === 'Buildings') {
            this.#legendWrapper = $('#bottomRightContent').find('#legendWrapperBuildings');
            this.#canvas = this.#legendWrapper.find('.legendCanvas');
            this.#legendLabel = this.#legendWrapper.find('#legendLabelBuildings');
        } */

    this.#buttons = $(this.#menuContainer).find("img");
    this.#imgContainer = this.#legendWrapper?.find("img");

    this.init();
  }

  init() {
    this.#imgContainer.css("transform", "scaleX(1)");
    this.#legendLabel?.css("color", "rgb(0, 0, 0)");

    /* if (this.#imgContainer.css('display') === 'none') {
            this.#buttons[0].hidden = true;
        } else if (this.#imgContainer.css('display') !== 'none') {
            this.#buttons[0].hidden = false;
        } */

    document.addEventListener("resetCustomColorScaling", () => {
      this.resetDialogValues();
    });

    this.#buttons[0].addEventListener("click", () => {
      this.customScale();
    });

    /* this.#buttons[1].addEventListener('click', () => {
            this.invertColors();
            this.refreshUi();
        });

        this.#buttons[2].addEventListener('click', () => {
            this.changeColorScheme();
        });

        this.#buttons[3].addEventListener('click', () => {
            this.resetColorScheme();
        }); */
  }

  refreshUi() {
    document.dispatchEvent(new Event("refreshUI"));
  }

  invertColors() {
    this.#imgContainer.css(
      "transform",
      this.#inverted ? "scaleX(1)" : "scaleX(-1)"
    );
    this.#inverted = !this.#inverted;
    this.#legendLabel?.css(
      "color",
      this.#inverted ? "rgb(255, 255, 255)" : "rgb(0, 0, 0)"
    );
  }

  getInverted = () => this.#inverted;

  changeColorScheme() {
    let that = this;
    d3.select("#colorPicker").remove();

    // add D3 color picker in interactionControlSquares div
    let colorPicker = d3
      .select("#interactionControlSquares")
      .append("input")
      .attr("type", "color")
      .attr("value", "#08306b")
      .attr("id", "colorPicker")
      .style("position", "relative");

    // add event listener to color picker
    colorPicker.on("change", function () {
      let color = d3.select(this).property("value");

      // change color of squares
      //d3.select('#legendWrapperSquares').selectAll('rect').style('fill', color);

      var canvas = document.createElement("canvas");
      canvas.width = 256;
      canvas.height = 1;
      var context = canvas.getContext("2d") as CanvasRenderingContext2D;
      var gradient = context?.createLinearGradient(0, 0, canvas.width, 0);
      gradient?.addColorStop(0, "white");
      gradient?.addColorStop(1, color);
      context.fillStyle = gradient;
      context?.fillRect(0, 0, canvas.width, canvas.height);
      let newSrc = canvas.toDataURL();

      that.changeLegendImageSrc(newSrc);

      //set squaresColor to color
      that.setSquaresColor(color);
      that.refreshUi();
    });

    colorPicker.on("mouseover", function () {
      d3.select(this).style("cursor", "pointer");
    });

    colorPicker.on("mouseout", function () {
      d3.select(this).style("cursor", "default");
      d3.select("#colorPicker").remove();
    });
  }

  changeLegendImageSrc(src: any) {
    this.#imgContainer.attr("src", src);
  }

  setSquaresColor(color: string) {
    this.#squaresColor = color;
  }

  getSquaresColor() {
    return this.#squaresColor;
  }

  resetColorScheme() {
    var canvas = document.createElement("canvas");
    canvas.width = 256;
    canvas.height = 1;
    var context = canvas.getContext("2d") as CanvasRenderingContext2D;
    var gradient = context.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop(0, "white");
    gradient.addColorStop(1, "#08306b");
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);
    let newSrc = canvas.toDataURL();
    this.changeLegendImageSrc(newSrc);
    this.setSquaresColor("#08306b");
    this.refreshUi();
  }

  customScale() {
    var that = this;
    var minValue = that.getCustomScaleMin() ? that.getCustomScaleMin() : 0.0;
    var maxValue = that.getCustomScaleMax() ? that.getCustomScaleMax() : 100.0;
    var customMinColor = that.getCustomMinColor()
      ? that.getCustomMinColor()
      : "#9e9e9e";
    var customMaxColor = that.getCustomMaxColor()
      ? that.getCustomMaxColor()
      : "#545353";
    var customMiddleColor = that.getCustomMiddleColor()
      ? that.getCustomMiddleColor()
      : "#d17d00";
    var interpolateBool = that.getInterpolateBool()
      ? that.getInterpolateBool()
      : false;
    var highestNumber = (maxValue / 2) * 3;
    highestNumber = Math.ceil(highestNumber);

    function openDialog() {
      // Destroy any existing dialogs
      $("#dialog").dialog("destroy");
      // Create a new dialog
      that.dialog = $(
        '<div id="dialog" title="Skala anpassen">' +
          '<fieldset id="max-group">' +
          "<legend>Obere Grenze:</legend>" +
          '<p>Obere Grenze: <input id="max" type="number" min="0" max="' +
          highestNumber +
          '" step="0.01" value="' +
          maxValue +
          '"></p>' +
          '<div id="max-slider"></div>' +
          //'<p>Farbe wenn grösser max.: <input type="color" id="customMaxColor" value="' + customMaxColor + '"></p>' +
          '<p>Farbe, wenn grösser Max.: <select id="customMaxColor" class="custom-select">' +
          '   <option value="#078b00" data-color="#078b00">Grün</option>' +
          '   <option value="#00008b" data-color="#00008b">Blau</option>' +
          '   <option value="#f94144" data-color="#f94144">Rot</option>' +
          '   <option value="#7d2f7d" data-color="#7d2f7d">Lila</option>' +
          '   <option value="#adadad" data-color="#adadad">Hell grau</option>' +
          '   <option value="#919191" selected="selected" data-color="#919191">Grau</option>' +
          "</select></p>" +
          "</fieldset>" +
          '<fieldset id="middle-group">' +
          "<legend>Mittlerer Bereich:</legend>" +
          //'<p>Farbe in der Mitte: <input type="color" id="customMiddleColor" value="' + customMiddleColor + '"></p>' +
          '<p>Farbe in der Mitte: <select id="customMiddleColor" class="custom-select">' +
          '   <option value="#078b00" data-color="#078b00">Grün</option>' +
          '   <option value="#00008b" selected="selected" data-color="#00008b">Blau</option>' +
          '   <option value="#f94144" data-color="#f94144">Rot</option>' +
          '   <option value="#7d2f7d" data-color="#7d2f7d">Lila</option>' +
          '   <option value="#adadad" data-color="#adadad">Hell grau</option>' +
          '   <option value="#919191" data-color="#919191">Grau</option>' +
          "</select></p>" +
          "</fieldset>" +
          '<fieldset id="min-group">' +
          "<legend>Untere Grenze:</legend>" +
          '<p>Untere Grenze: <input id="min" type="number" min="0" max="' +
          highestNumber +
          '" step="0.01" value="' +
          minValue +
          '"></p>' +
          '<div id="min-slider"></div>' +
          //'<p>Farbe wenn kleiner min.: <input type="color" id="customMinColor" value="' + customMinColor + '"></p>' +
          '<p>Farbe, wenn kleiner Min.: <select id="customMinColor" class="custom-select">' +
          '   <option value="#078b00" data-color="#078b00">Grün</option>' +
          '   <option value="#00008b" data-color="#00008b">Blau</option>' +
          '   <option value="#f94144" data-color="#f94144">Rot</option>' +
          '   <option value="#7d2f7d" data-color="#7d2f7d">Lila</option>' +
          '   <option value="#adadad" selected="selected" data-color="#adadad">Hell grau</option>' +
          '   <option value="#919191" data-color="#919191">Grau</option>' +
          "</select></p>" +
          "</fieldset>" +
          '<p>Einfarbig: <input type="checkbox" id="interpolateBool" ' +
          (interpolateBool ? "checked" : "") +
          "></p>" +
          "</div>"
      ).dialog({
        autoOpen: false,
        height: 685,
        width: 520,
        modal: true,
        resizable: false,
        position: {
          my: "right bottom",
          at: "right-15% bottom-20%",
          of: window,
        },
        buttons: {
          Abbrechen: function () {
            $(this).dialog("close");
          },
          Reset: function () {
            that.resetDialogValues();
            $(this).dialog("close");
            that.refreshUi();
          },
          Anwenden: function () {
            var minValueDialog = parseFloat($("#min").val() as string);
            var maxValueDialog = parseFloat($("#max").val() as string);
            var customMinColorDialog = $("#customMinColor").val();
            var customMaxColorDialog = $("#customMaxColor").val();
            var customMiddleColorDialog = $("#customMiddleColor").val();
            var interpolateBoolDialog = $("#interpolateBool").is(":checked");

            if (minValueDialog > maxValueDialog) {
              alert(
                "Die untere Grenze muss kleiner als die obere Grenze sein!"
              );
              return;
            }

            that.setCustomScaleMin(minValueDialog);
            that.setCustomScaleMax(maxValueDialog);
            that.setCustomMinColor(customMinColorDialog as string);
            that.setCustomMaxColor(customMaxColorDialog as string);
            that.setCustomMiddleColor(customMiddleColorDialog as string);
            that.setCustomScaleBool(true);
            that.setInterpolateBool(interpolateBoolDialog);

            if (!interpolateBoolDialog) {
              var canvas = document.createElement("canvas");
              canvas.width = 256;
              canvas.height = 1;
              var context = canvas.getContext("2d") as CanvasRenderingContext2D;
              var gradient = context.createLinearGradient(
                0,
                0,
                canvas.width,
                0
              );
              gradient.addColorStop(0, customMinColorDialog as string);
              gradient.addColorStop(0.5, customMiddleColorDialog as string);
              gradient.addColorStop(1, customMaxColorDialog as string);
              context.fillStyle = gradient;
              context.fillRect(0, 0, canvas.width, canvas.height);
              let src = canvas.toDataURL();
              that.changeLegendImageSrc(src);
            } else {
              var canvas = document.createElement("canvas");
              canvas.width = 256;
              canvas.height = 1;
              var context = canvas.getContext("2d") as CanvasRenderingContext2D;

              // Define the color stops and their positions
              var colorStops = [
                { color: customMinColorDialog, position: 0 },
                { color: customMiddleColorDialog, position: 0.5 },
                { color: customMaxColorDialog, position: 1 },
              ];
              // Calculate the width for each color band
              var bandWidth = canvas.width / colorStops.length;
              // Loop through the color stops and draw rectangles
              for (var i = 0; i < colorStops.length; i++) {
                var stop = colorStops[i];
                context.fillStyle = stop.color as any;
                context.fillRect(i * bandWidth, 0, bandWidth, canvas.height);
              }
              let src = canvas.toDataURL();
              that.changeLegendImageSrc(src);
            }

            $(this).dialog("close");
            that.refreshUi();
          },
        },
        close: function () {
          $(this).dialog("close");
        },
      });

      // Add class to disable hover effect for every option in each select
      $("#customMaxColor, #customMiddleColor, #customMinColor")
        .find("option")
        .addClass("no-hover");
      $("#customMaxColor, #customMiddleColor, #customMinColor").addClass(
        "no-hover"
      );

      // Add change event listener for #customMaxColor
      $("#customMaxColor").on("change", function () {
        var selectedColor = $(this).find("option:selected").data("color");
        $(this).css("background-color", selectedColor);
      });

      $("#customMiddleColor").on("change", function () {
        var selectedColor = $(this).find("option:selected").data("color");
        $(this).css("background-color", selectedColor);
      });

      $("#customMinColor").on("change", function () {
        var selectedColor = $(this).find("option:selected").data("color");
        $(this).css("background-color", selectedColor);
      });

      // Style the colored squares next to the options
      $("#customMinColor option").each(function () {
        var color = $(this).data("color");
        $(this).css("background-color", color);
      });

      $("#customMaxColor option").each(function () {
        var color = $(this).data("color");
        $(this).css("background-color", color);
      });

      $("#customMiddleColor option").each(function () {
        var color = $(this).data("color");
        $(this).css("background-color", color);
      });

      // Initialize sliders with values based on input
      $("#min-slider").slider({
        range: "min",
        min: 0,
        max: highestNumber,
        value: minValue,
        slide: function (event, ui) {
          $("#min").val(ui.value as any);
        },
      });

      $("#max-slider").slider({
        range: "min",
        min: 0,
        max: highestNumber,
        value: maxValue,
        slide: function (event, ui) {
          $("#max").val(ui.value as any);
        },
      });

      // Link input values to sliders
      $("#min").on("input", function () {
        let value = parseInt($(this).val() as any);
        $("#min-slider").slider("value", value);
      });
      $("#max").on("input", function () {
        let value = parseInt($(this).val() as any);
        $("#max-slider").slider("value", value);
      });

      $("#interpolateBool").on("change", function () {
        interpolateBool = $(this).prop("checked");
      });

      // Trigger change event to set initial background color
      $("#customMaxColor").trigger("change");
      $("#customMiddleColor").trigger("change");
      $("#customMinColor").trigger("change");

      that.dialog.hide().fadeIn(500);

      that.dialog.dialog("open");
    }

    // Call this function whenever you want to open the dialog.
    openDialog();
  }

  resetDialogValues() {
    this.#customScaleMin = 0.0;
    this.#customScaleMax = 100.0;
    this.#customScaleBool = false;
    this.#customMinColor = "#577590";
    this.#customMaxColor = "#f94144";
    this.#customMiddleColor = "#90be6d";

    // canvas is needed for the legend image
    var canvas = document.createElement("canvas");
    canvas.width = 256;
    canvas.height = 1;
    var context = canvas.getContext("2d") as CanvasRenderingContext2D;
    var gradient = context.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop(0, "white");
    gradient.addColorStop(1, "#08306b");
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);
    let newSrc = canvas.toDataURL();
    this.changeLegendImageSrc(newSrc);
  }

  // getter and setter
  getCustomScaleMin() {
    return this.#customScaleMin;
  }

  setCustomScaleMin(min: number) {
    this.#customScaleMin = min;
  }

  getCustomScaleMax() {
    return this.#customScaleMax;
  }

  setCustomScaleMax(max: number) {
    this.#customScaleMax = max;
  }

  getCustomScaleBool() {
    return this.#customScaleBool;
  }

  setCustomScaleBool(bool: boolean) {
    this.#customScaleBool = bool;
  }

  getCustomMinColor() {
    return this.#customMinColor;
  }

  setCustomMinColor(color: string) {
    this.#customMinColor = color;
  }

  getCustomMaxColor() {
    return this.#customMaxColor;
  }

  setCustomMaxColor(color: string) {
    this.#customMaxColor = color;
  }

  getCustomMiddleColor() {
    return this.#customMiddleColor;
  }

  setCustomMiddleColor(color: string) {
    this.#customMiddleColor = color;
  }

  getInterpolateBool() {
    return this.#interpolateBool;
  }

  setInterpolateBool(bool: boolean) {
    this.#interpolateBool = bool;
  }
}
